import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-pcc-instructions-dialog',
    templateUrl: './pcc-instructions-dialog.component.html',
    styleUrls: ['./pcc-instructions-dialog.component.scss'],
    standalone: false
})
export class PccInstructionsDialogComponent {
  constructor(public dialogRef: MatDialogRef<PccInstructionsDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
  
}
